import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1880. 請求タスク購読解除
 * [DELETE] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/invoice_tasks/:invoice_task_id/invoice_task_subscriptions/:id
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  task_id: number;
  id: number;
};

const destroyInvoiceTaskSubscription = (props: Props) => {
  return axios.delete(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/invoice_tasks/${props.task_id}/invoice_task_subscriptions/${props.id}`
  );
};

export const useDestroyInvoiceTaskSubscription = () => {
  return useMutation({
    mutationFn: destroyInvoiceTaskSubscription
  });
};
